import { createAsyncThunk } from "@reduxjs/toolkit";
import { Configuration, TrialsApi, EntitlementsApi } from "api";
import { getBasePath } from "common/getConfiguration";
import { closeSnackbar, openSnackbar } from "features/ui";
import { isError } from "lodash";
import { AxiosError } from "axios";
import { getTranslationID } from "translation";
import { TrialState } from "./state";

export const initialAsync = createAsyncThunk<
  TrialState,
  void,
  {
    // rejectした時の返却値の型
    rejectValue: {
      /* Empty Object */
    };
  }
>("trial/initialAsync", async (args, thunkApi) => {
  // apiのConfigurationを取得する
  const basePath = getBasePath();

  const config = new Configuration({ basePath });
  try {
    // トライアル一覧取得するAPI呼び出し
    const trialsApi = new TrialsApi(config);
    const { data } = await trialsApi.getTrial();
    return {
      apps: {
        initialize: "Initialized",
      },
      domains: {
        Products: data.products,
      },
    };
  } catch (e) {
    if (isAxiosError(e)) {
      if (e.response?.status === 401) {
        return thunkApi.rejectWithValue({});
      }
    }
    thunkApi.dispatch(
      openSnackbar({
        level: "error",
        message: getTranslationID("common.message.serverInternalError"),
      })
    );
    return thunkApi.rejectWithValue({});
  }
});

export const trialAsync = createAsyncThunk<
  {
    /* Empty Object */
  },
  { productId: string; userId: string; featureId: string; licenseId: string },
  {
    // rejectした時の返却値の型
    rejectValue: {
      /* Empty Object */
    };
  }
>("trial/trialAsync", async (args, thunkApi) => {
  // apiのConfigurationを取得する
  const basePath = getBasePath();

  const { productId, featureId, licenseId } = args;

  const config = new Configuration({ basePath });
  try {
    // トライアルライセンスを作成するAPI呼び出し
    const entitlementsApi = new EntitlementsApi(config);
    const { data } = await entitlementsApi.createTrialLicense({
      productId,
      featureId,
      licenseId,
    });

    thunkApi.dispatch(closeSnackbar());
    thunkApi.dispatch(
      openSnackbar({
        level: "info",
        message: getTranslationID("trialPage.message.trialSuccess"),
      })
    );

    return data;
  } catch (e) {
    if (isAxiosError(e)) {
      // ステータスコードが409 Conflictの場合はライセンスの競合として処理
      if (e.response?.status === 409) {
        thunkApi.dispatch(
          openSnackbar({
            level: "info",
            message: getTranslationID("trialPage.message.trialConflict"),
          })
        );
        return thunkApi.rejectWithValue({});
      }
      if (e.response?.status === 401) {
        return thunkApi.rejectWithValue({});
      }
    }
    thunkApi.dispatch(
      openSnackbar({
        level: "error",
        message: getTranslationID("common.message.serverInternalError"),
      })
    );
    return thunkApi.rejectWithValue({});
  }
});

const isAxiosError = (arg: unknown): arg is AxiosError => {
  if (!isError(arg)) {
    return false;
  }
  const errorValue = arg as AxiosError;
  return errorValue.isAxiosError;
};
